var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.375,
    y: 12.7495,
    width: 38.25,
    height: 27.625,
    rx: 4.25,
    stroke: "url(#paint0_linear_1146_2396)",
    strokeWidth: 3.1875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 31.8745H14.8962",
    stroke: "url(#paint1_linear_1146_2396)",
    strokeWidth: 3.1875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23.3745H44.625",
    stroke: "url(#paint2_linear_1146_2396)",
    strokeWidth: 3.1875,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_2396",
    x1: 6.375,
    y1: 26.562,
    x2: 44.625,
    y2: 26.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_2396",
    x1: 14.875,
    y1: 32.3745,
    x2: 14.8963,
    y2: 32.3745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_2396",
    x1: 8.5,
    y1: 23.8745,
    x2: 44.625,
    y2: 23.8745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.1cd648e140663f5d6cf9516338ca2fb9.svg";
export { ForwardRef as ReactComponent };